<template>
  <div>
    <div id="stats"></div>
    <div style="z-index: 2;position: absolute;top:0;left: 0;font-family: 'Press Start 2P', cursive;font-size: 54px;">
      {{score}}
    </div>
    <div id="debug" style="position: absolute;top:40vh;width: 100vw;font-size: 6vh;text-align: center;z-index: 1000">
      {{debugMeg}}
    </div>
    <div class="navigations noto300" v-show="navigations.length > 0">
      <div class="navigation" :key="navigation.text" v-for="navigation in navigations">
        <span class="material-icons-outlined" :class="navigation.icon">{{navigation.icon}}</span>
        {{navigation.text}}
      </div>
    </div>
<!--    <div class="navigations-mobile noto300" v-show="isMobile && navigations.length > 0">-->
<!--      <div class="navigation-mobile" :key="navigation.text" v-for="navigation in navigations">-->
<!--        <span class="material-icons-outlined" :class="navigation.icon">{{navigation.icon}}</span>-->
<!--        {{navigation.text}}-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {FitUtil} from "./common/FitUtil";

export default {
  name: "CommonDisplay",
  props: {
    score: {
      type: Number,
    },
    debugMeg: {
      type: String,
    },
    navigations: {
      type: Array,
    }
  },
  data() {
    return {
      isMobile: FitUtil.isMobile(),
    }
  },
}
</script>

<style scoped>
.navigations {
  position: absolute;
  top: 10vh;
  right: 0;
  font-size: 3.5vh;
  font-weight: 400;
  line-height: 2;
  padding: 1vh 2vh;
  border-top-left-radius: 3vh;
  border-bottom-left-radius: 3vh;
  z-index: 2;
  background: rgba(255,255,255,0.9);
  border: 4px solid #e74a23;
  border-right: none;
}
.navigation {
  /*text-align: right;*/
}

@media (max-aspect-ratio: 1/1) {
  .navigations {
    position: absolute;
    top: auto;
    right: auto;
    left: 0;
    bottom: 15vh;
    font-size: 3vh;
    width: 100vw;
    padding: 0;
    border-radius: 0;
    border: none;
  }
  .navigation-mobile {
    line-height: 2;
    font-weight: 400;
  }
}
/*.navigations-mobile {*/
/*  position: absolute;*/
/*  left: 0;*/
/*  top: auto;*/
/*  bottom: 15vh;*/
/*  width: 100vw;*/
/*  font-size: 3vh;*/
/*  z-index: 2;*/
/*  background: rgba(255,255,255,0.9);*/
/*}*/
/*.navigation-mobile {*/
/*  line-height: 2;*/
/*  font-weight: 400;*/
/*}*/
.material-icons-outlined {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 3.5vh;
  line-height: 1;
  /*height: 6vh;*/
  /*line-height: 6vh;*/
}
.warning {
  color: orange;
}
.check {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonDisplay.vue